import axios from 'axios'
import config from './Koneksi_astor'
import { attachJwtInterceptor } from '../../utils/jwtInterceptor'

const instance = axios.create({
    baseURL: config.baseURL
})

export default attachJwtInterceptor(instance)
